module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA2.d6aa09f7.jpg";